/* PayPlaxe · Sapphire — progressive enhancements (content is never touched).
   1. pp-scrolled on <html> — sticky header shadow.
   2. Scroll-reveal with stagger; above-the-fold elements are never hidden.
   3. Hero canvas: a skyline of storefront silhouettes with a dots-and-lines
      particle network on top (cursor highlights nearby nodes).
   Safe without JS: .pp-reveal classes are only ever added here. */
(function () {
  var root = document.documentElement;
  root.classList.add('pp-js');

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- fixed header ---------- */
  var headerWrap = document.getElementById('shopify-section-header');
  function setHeaderHeight() {
    if (headerWrap) root.style.setProperty('--pp-header-h', headerWrap.offsetHeight + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  var heroForHeader = document.querySelector('.template-index .main-content > .shopify-section:first-child');
  var HERO_DARK_FRACTION = 1; // portion of the hero that reads as dark under the header
  function onScroll() {
    if ((window.scrollY || window.pageYOffset || 0) > 12) {
      root.classList.add('pp-scrolled');
    } else {
      root.classList.remove('pp-scrolled');
    }
    // white header controls while the dark part of the hero is underneath;
    // the switch happens when that edge crosses the middle of the header
    if (heroForHeader) {
      var headerH = headerWrap ? headerWrap.offsetHeight : 74;
      var r = heroForHeader.getBoundingClientRect();
      if (r.top + r.height * HERO_DARK_FRACTION > headerH * 0.5) {
        root.classList.add('pp-on-hero');
      } else {
        root.classList.remove('pp-on-hero');
      }
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- scroll reveal ---------- */
  if ('IntersectionObserver' in window && !reduceMotion) {
    var targets = Array.prototype.slice.call(document.querySelectorAll(
      [
        '.pp-app-grid > .grid__item',
        '.index-section .grid--blog > .grid__item',
        '.index-section .section-header',
        '.newsletter-section .section-header',
        '.newsletter-section .input-group'
      ].join(',')
    ));

    // never hide elements visible on load — no flash, no redundant animation
    targets = targets.filter(function (el) {
      return el.getBoundingClientRect().top > window.innerHeight * 0.92;
    });

    targets.forEach(function (el) { el.classList.add('pp-reveal'); });

    var finish = function (el) {
      el.classList.remove('pp-reveal');
      el.classList.remove('pp-in');
      el.style.removeProperty('--pp-d');
    };

    if (targets.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          // stagger by the visual column of the current grid
          var delay = 0;
          var parent = el.parentElement;
          if (parent && getComputedStyle(parent).display === 'grid') {
            var cols = getComputedStyle(parent).gridTemplateColumns.split(' ').length || 1;
            var i = 0, p = el;
            while ((p = p.previousElementSibling)) i++;
            delay = (i % cols) * 70;
          }
          el.style.setProperty('--pp-d', delay + 'ms');
          el.classList.add('pp-in');
          io.unobserve(el);
          setTimeout(function () { finish(el); }, 750 + delay);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

      targets.forEach(function (el) { io.observe(el); });

      // safety net: after 5s reveal anything stuck in the dead zone
      setTimeout(function () {
        targets.forEach(function (el) {
          if (el.classList.contains('pp-reveal') && !el.classList.contains('pp-in')) finish(el);
        });
      }, 5000);
    }
  }

  /* ---------- newsletter canvas: dots-and-lines particle network ---------- */
  (function () {
  var host = document.querySelector('.newsletter-section');
  if (!host || !window.requestAnimationFrame) return;

  var canvas = document.createElement('canvas');
  canvas.className = 'pp-net';
  canvas.setAttribute('aria-hidden', 'true');
  host.insertBefore(canvas, host.firstChild);
  var ctx = canvas.getContext('2d');
  if (!ctx) return;

  var W = 0, H = 0, DPR = Math.min(window.devicePixelRatio || 1, 2);
  var nodes = [];
  var mouse = { x: -9999, y: -9999 };
  var LINK = 120;   // max distance for a line between nodes
  var NEAR = 160;   // cursor highlight radius

  function resize() {
    W = host.clientWidth;
    H = host.clientHeight;
    canvas.width = W * DPR;
    canvas.height = H * DPR;
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    var count = Math.min(64, Math.max(24, Math.round(W * H / 14000)));
    nodes = [];
    for (var i = 0; i < count; i++) {
      nodes.push({
        x: Math.random() * W,
        y: Math.random() * H,
        vx: (Math.random() - 0.5) * 0.35,
        vy: (Math.random() - 0.5) * 0.35
      });
    }
  }

  function frame() {
    ctx.clearRect(0, 0, W, H);
    var i, j, a, b;
    for (i = 0; i < nodes.length; i++) {
      a = nodes[i];
      a.x += a.vx; a.y += a.vy;
      if (a.x < 0 || a.x > W) a.vx *= -1;
      if (a.y < 0 || a.y > H) a.vy *= -1;
    }
    for (i = 0; i < nodes.length; i++) {
      a = nodes[i];
      var adx = a.x - mouse.x, ady = a.y - mouse.y;
      var aNear = Math.sqrt(adx * adx + ady * ady) < NEAR;
      for (j = i + 1; j < nodes.length; j++) {
        b = nodes[j];
        var dx = a.x - b.x, dy = a.y - b.y;
        var d = Math.sqrt(dx * dx + dy * dy);
        if (d > LINK) continue;
        var alpha = (1 - d / LINK);
        if (aNear) {
          ctx.strokeStyle = 'rgba(220,233,255,' + (alpha * 0.45).toFixed(3) + ')';
        } else {
          ctx.strokeStyle = 'rgba(255,255,255,' + (alpha * 0.16).toFixed(3) + ')';
        }
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(a.x, a.y);
        ctx.lineTo(b.x, b.y);
        ctx.stroke();
      }
      ctx.fillStyle = aNear ? 'rgba(255,255,255,.95)' : 'rgba(255,255,255,.38)';
      ctx.beginPath();
      ctx.arc(a.x, a.y, aNear ? 2.2 : 1.6, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  resize();

  if (reduceMotion) {
    frame(); // one static frame
    window.addEventListener('resize', function () { resize(); frame(); });
    return;
  }

  var running = true, rafId = null;
  function loop() {
    frame();
    rafId = running ? window.requestAnimationFrame(loop) : null;
  }

  host.addEventListener('mousemove', function (e) {
    var r = canvas.getBoundingClientRect();
    mouse.x = e.clientX - r.left;
    mouse.y = e.clientY - r.top;
  });
  host.addEventListener('mouseleave', function () {
    mouse.x = -9999; mouse.y = -9999;
  });

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resize, 150);
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      if (visible && !running) { running = true; loop(); }
      if (!visible) { running = false; }
    }).observe(host);
  }
  loop();
  })();

  /* ---------- hero canvas: storefront skyline + particle network ---------- */
  var hero = document.querySelector('.template-index .main-content > .shopify-section:first-child');
  if (!hero || !window.requestAnimationFrame) return;

  var canvas = document.createElement('canvas');
  canvas.className = 'pp-net';
  canvas.setAttribute('aria-hidden', 'true');
  hero.insertBefore(canvas, hero.firstChild);
  var ctx = canvas.getContext('2d');
  if (!ctx) return;

  var W = 0, H = 0, DPR = Math.min(window.devicePixelRatio || 1, 2);
  var nodes = [];
  var skyline = null; // offscreen layer, redrawn only on resize
  var mouse = { x: -9999, y: -9999 };
  var LINK = 130;   // max distance for a line between nodes
  var NEAR = 170;   // cursor highlight radius

  // one storefront: facade, roofline sign, awning, door and lit windows
  function drawShop(s, x, w, h, baseY, alpha, detailed) {
    var y = baseY - h;
    s.fillStyle = 'rgba(143,186,255,' + alpha + ')';
    s.fillRect(x, y, w, h);
    if (!detailed) return;
    // sign board
    s.fillStyle = 'rgba(143,186,255,' + (alpha + 0.05) + ')';
    s.fillRect(x + w * 0.16, y + 7, w * 0.68, 7);
    // awning
    s.fillRect(x + 3, y + h * 0.42, w - 6, 5);
    // door
    s.fillStyle = 'rgba(11,18,32,0.55)';
    s.fillRect(x + w * 0.42, baseY - h * 0.34, w * 0.16, h * 0.34);
    // windows
    s.fillStyle = 'rgba(143,186,255,' + (alpha + 0.10) + ')';
    var wx = x + 6;
    while (wx < x + w - 12) {
      s.fillRect(wx, y + h * 0.58, 8, 10);
      wx += 15;
    }
  }

  function drawShopRow(s, baseY, alpha, minH, maxH, detailed) {
    var x = -14;
    while (x < W + 14) {
      var w = 44 + Math.random() * 72;
      var h = minH + Math.random() * (maxH - minH);
      drawShop(s, x, w, h, baseY, alpha, detailed);
      x += w + 5 + Math.random() * 22;
    }
  }

  function buildSkyline() {
    skyline = document.createElement('canvas');
    skyline.width = W * DPR;
    skyline.height = H * DPR;
    var s = skyline.getContext('2d');
    s.setTransform(DPR, 0, 0, DPR, 0, 0);
    // two depth rows: distant blocks behind, detailed storefronts in front
    drawShopRow(s, H, 0.045, 64, 130, false);
    drawShopRow(s, H, 0.07, 34, 72, true);
    // faint street line
    s.fillStyle = 'rgba(143,186,255,0.14)';
    s.fillRect(0, H - 1, W, 1);
  }

  function resize() {
    W = hero.clientWidth;
    H = hero.clientHeight;
    canvas.width = W * DPR;
    canvas.height = H * DPR;
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    buildSkyline();
    var count = Math.min(90, Math.max(36, Math.round(W * H / 16000)));
    nodes = [];
    for (var i = 0; i < count; i++) {
      nodes.push({
        x: Math.random() * W,
        y: Math.random() * H,
        vx: (Math.random() - 0.5) * 0.35,
        vy: (Math.random() - 0.5) * 0.35
      });
    }
  }

  function frame() {
    ctx.clearRect(0, 0, W, H);
    if (skyline) ctx.drawImage(skyline, 0, 0, W, H);
    var i, j, a, b;
    for (i = 0; i < nodes.length; i++) {
      a = nodes[i];
      a.x += a.vx; a.y += a.vy;
      if (a.x < 0 || a.x > W) a.vx *= -1;
      if (a.y < 0 || a.y > H) a.vy *= -1;
    }
    for (i = 0; i < nodes.length; i++) {
      a = nodes[i];
      var adx = a.x - mouse.x, ady = a.y - mouse.y;
      var aNear = Math.sqrt(adx * adx + ady * ady) < NEAR;
      for (j = i + 1; j < nodes.length; j++) {
        b = nodes[j];
        var dx = a.x - b.x, dy = a.y - b.y;
        var d = Math.sqrt(dx * dx + dy * dy);
        if (d > LINK) continue;
        var alpha = (1 - d / LINK);
        if (aNear) {
          ctx.strokeStyle = 'rgba(143,186,255,' + (alpha * 0.35).toFixed(3) + ')';
        } else {
          ctx.strokeStyle = 'rgba(255,255,255,' + (alpha * 0.10).toFixed(3) + ')';
        }
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(a.x, a.y);
        ctx.lineTo(b.x, b.y);
        ctx.stroke();
      }
      ctx.fillStyle = aNear ? 'rgba(143,186,255,.9)' : 'rgba(255,255,255,.28)';
      ctx.beginPath();
      ctx.arc(a.x, a.y, aNear ? 2.2 : 1.6, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  resize();

  if (reduceMotion) {
    frame(); // one static frame
    window.addEventListener('resize', function () { resize(); frame(); });
    return;
  }

  var running = true, rafId = null;
  function loop() {
    frame();
    rafId = running ? window.requestAnimationFrame(loop) : null;
  }

  hero.addEventListener('mousemove', function (e) {
    var r = canvas.getBoundingClientRect();
    mouse.x = e.clientX - r.left;
    mouse.y = e.clientY - r.top;
  });
  hero.addEventListener('mouseleave', function () {
    mouse.x = -9999; mouse.y = -9999;
  });

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resize, 150);
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      if (visible && !running) { running = true; loop(); }
      if (!visible) { running = false; }
    }).observe(hero);
  }
  loop();
})();
